import type { StyleRule } from '@archipro-design/aria';
import {
    dividerClassName,
    getScrollbarStyle,
    pxToRem,
    DESKTOP_TOP_NAV_HEIGHT_WITH_SECOND_NAV,
    MOBILE_TOP_NAV_HEIGHT_FULL_LOGO,
} from '@archipro-design/aria';

/**
 * Search / form TextInputs: icon size + hide Fluent divider (pseudo-element thins under
 * transform/backdrop-blur). Pair with `TaggingModalFieldUnderline` after each input.
 */
export const SearchTextInput: StyleRule = () => ({
    '& svg': {
        height: pxToRem(26),
        width: pxToRem(26),
    },

    [`& .${dividerClassName}`]: {
        display: 'none',
    },
});

/** Sizing and fill colour for the aria Loader spinner (page-builder dark scrim). */
export const Loader: StyleRule = ({ theme }) => ({
    height: pxToRem(108),
    width: pxToRem(108),
    '& svg': {
        fill: theme.siteVariables.colors.primitive.white,
    },
});

/** Tagging search modals — dark spinner so it stays visible on the light row-hover scrim. */
export const TaggingSearchLoader: StyleRule = ({ theme }) => ({
    height: pxToRem(108),
    width: pxToRem(108),
    '& svg': {
        fill: theme.siteVariables.colors.primitive.black,
    },
});

// --- Styles below are still consumed by the page-builder ProductSearchModal ---
// (packages/web/app/modules/page-builder/component/edit/product-search-modal
//  and edit-article/product-search-modal)

export const SearchField: StyleRule = ({ theme }) => ({
    padding: pxToRem(16),
    scrollMarginTop: pxToRem(MOBILE_TOP_NAV_HEIGHT_FULL_LOGO),
    [theme.screen.laptop]: {
        scrollMarginTop: pxToRem(DESKTOP_TOP_NAV_HEIGHT_WITH_SECOND_NAV),
    },
});

export const SearchBody: StyleRule = ({ theme }) => ({
    paddingLeft: pxToRem(8),
    maxHeight: pxToRem(454),
    overflow: 'none',
    overflowY: 'auto',
    ...getScrollbarStyle(theme, '0'),
});

export const SearchLoading: StyleRule = () => ({
    width: '100%',
    height: '100%',
    background: `rgba(0,0,0,0.3)`,
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});

export const EmptyResults: StyleRule = () => ({
    marginLeft: pxToRem(8),
});

export const ContentWrapper: StyleRule = () => ({
    height: pxToRem(552),
});
